import axios from "axios";
import Vue from "vue";

const ENDPOINT = `${Vue.prototype.API_ENDPOINT}/graphql`;

export default {
  namespaced: true,

  state: {
    testNavigationControl: null,
  },

  mutations: {
    SET_TEST_NAVIGATION_CONTROL(_state, payload) {
      const state = _state;
      let testNavigation = localStorage.getItem("testNavigation");
      if (testNavigation) testNavigation = atob(testNavigation);
      testNavigation = JSON.parse(testNavigation) || {};

      if (testNavigation && payload) {
        Object.keys(payload).forEach((key) => {
          testNavigation[key] = payload[key];
        });
      }

      state.testNavigationControl =
        testNavigation != null
          ? { ...state.testNavigationControl, ...testNavigation }
          : payload;
      localStorage.setItem(
        "testNavigation",
        btoa(JSON.stringify(state.testNavigationControl))
      );
    },
  },

  getters: {},

  actions: {
    subscriptionTests({ rootState }, obj = {}) {
      const userId =
        rootState.user.profile == null
          ? ""
          : `userId: ${rootState.user.profile.id}, `;
      if (obj.length == 0) return;
      const params = new URLSearchParams();
      params.append(
        "query",
        `

      query {
        subscriptionTests(
          ${userId},
          opportunityId: ${obj.opportunityId},
          originCompany: ${obj.companyId || rootState.companyId},
          ${obj.token ? ` token: "${obj.token}", ` : ""}
          ${
            obj.useExistingScore
              ? ` useExistingScore: ${obj.useExistingScore}, `
              : ""
          }
          ${obj.redoTests ? ` redoTests: ${obj.redoTests}, ` : ""}
          ${obj.finishedTests ? ` finishedTests: ${obj.finishedTests}, ` : ""}
          ${obj.requiredIn ? ` requiredIn: "${obj.requiredIn}", ` : ""}
        ){
          json,
          showMindsightQuestion
        }
      }
      `
      );

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    subscriptionRecentTests({ rootState }, obj = {}) {
      const userId =
        rootState.user.profile == null
          ? ""
          : `userId: ${rootState.user.profile.id}, `;
      if (obj.length == 0) return;
      const params = new URLSearchParams();
      params.append(
        "query",
        `

      query {
        subscriptionRecentTests(
          ${userId},
          originCompany: ${obj.companyId || rootState.companyId},
          testIds: [${obj.testIds}]
        ){
          json
        }
      }
      `
      );

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    headerTests({ rootState }, obj = {}) {
      const userId = rootState.user.profile == null ? "" : `userId: ${rootState.user.profile.id}`;

      if (obj.length == 0) return;

      const params = new URLSearchParams();

      params.append(
        "query",
        `
          query {
            testSummary(
              opportunityId: ${obj.opportunityId},
              ${userId},
              sourceTestId: ${obj.sourceTestId}
            ) {
              json
            }
          }
        `
      );

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    testCover({ rootState }, obj = {}) {
      const userId =
        rootState.user.profile == null
          ? `userId: ${obj.user_id},`
          : `userId: ${rootState.user.profile.id}, `;
      if (obj.length == 0) return;

      const params = new URLSearchParams();
      params.append(
        "query",
        `
      query {
        testCover(
          ${userId},
          opportunityId: ${obj.opportunityId},
          testId: ${obj.testId}
        ){
          json
        }
      }
      `
      );

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    testQuestion({ rootState }, obj = {}) {
      if (obj.length == 0) return;

      const params = new URLSearchParams();
      params.append(
        "query",
        `
      query {
        testQuestion(url: "${Vue.prototype.PLATFORM_TEST}/v1/header/${obj.headerTestId}/questions/${obj.questionId}") {
          json
        }
      }
      `
      );

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    saveTestQuestion({ rootState }, obj = {}) {
      const params = new URLSearchParams();

      params.append(
        "query",
        `
        mutation {
          saveTestQuestion(
            url: "${obj.url}",
            answers: [${obj.answers}],
            ${obj.url_movie ? ` url_movie: "${obj.url_movie}", ` : ""}
            ${obj.text_answer ? ` text_answer: ${JSON.stringify(obj.text_answer)}, ` : ""}
            time_to_finish: ${obj.time_to_finish}
          )
          {
            json
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    returnPrimeiraEscolha({ rootState }, obj = {}) {
      if (obj.length == 0) return;

      const params = new URLSearchParams();
      params.append(
        "query",
        `
      mutation {
        returnPrimeiraEscolha(
          opportunity_id: ${obj.opportunity_id},
          user_id: ${obj.user_id},
          source_test_id: ${obj.source_test_id}
        )
        {
          success
        }
      }
    `
      );

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    returnTest({ rootState }, obj = {}) {
      if (obj.length == 0) return;

      const params = new URLSearchParams();
      params.append(
        "query",
        `
          mutation {
            returnTest(
              opportunity_id: ${obj.opportunity_id},
              user_id: ${obj.user_id},
              source_test_id: ${obj.source_test_id}
            )
            {
              success
            }
          }
        `
      );

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },


  },
};
